import React from "react"
import { IconWrapper, IconPathAnimated } from "shared/Styles/Icons"
import styled, { css } from "styled-components"

const lines = css`
  content: "";
  background-color: ${({color}) => color};
  transition: background-color 0.5s ease-in-out;
  width: 100px;
  height: 1px;
  position: absolute;
  top: 50%;
`
const FoundationWrapper = styled.div`
  position: relative;
  width: 225px;
  @media screen and (min-width: ${props =>
      props.theme.breakpoints.tabletSmall}) {
    &::after {
      ${lines}
      left: -45px;
      transform: translateY(-50%) scaleX(1);
      animation: logoAnimation 1s ease-in;
      transform-origin: right;
    }
    &::before {
      content: "";
      ${lines}
      right: -40px;
      transform: translateY(-50%) scaleX(1);
      animation: logoAnimation 1s ease-in;
      transform-origin: left;
    }
    @keyframes logoAnimation {
      from {
        transform: scaleX(0)
      }
      to {
        transform: scaleX(1)
      }
    }
  }
`

const FoundationLogo = ({ width, height, color }) => (
  <FoundationWrapper color={color}>
    <IconWrapper
      id="Warstwa_1"
      version="1.1"
      width={"225px"}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 500 42.7"
      xmlSpace="preserve"
    >
      <g>
        <IconPathAnimated
          color={color}
          d="M147,29.2h7.5c4.5,0,6.7,0.8,6.7,3.6v0.1c0,1.7-0.9,2.5-2.8,2.9c2.2,0.3,3.1,1.1,3.1,3v0.1
		c0,1-0.3,1.8-0.8,2.3c-1.1,1.1-3.1,1.6-6.1,1.6H147V29.2z M150.1,34.5h4.7c0.7,0,1.2,0,1.7-0.1c1-0.1,1.5-0.5,1.5-1.3v-0.1
		c0-0.4-0.1-0.7-0.3-1c-0.5-0.4-1.4-0.5-3-0.5h-4.6V34.5z M150.1,40.1h4.1c1.1,0,1.9,0,2.5-0.1c1.2-0.2,1.5-0.6,1.5-1.3v-0.1
		c0-0.4-0.1-0.8-0.3-1c-0.4-0.4-1.5-0.5-3.5-0.5h-4.4V40.1z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M171.1,42.7V29.2h12.9v2.7h-9.9v2.7h8.4v2.7h-8.4v2.7h10.3v2.8H171.1z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M197.5,39v3.8h-3.2V29.2h3.2v6.5l7.4-6.5h4.3l-5.9,5.1l6.2,8.4h-3.8L201,36L197.5,39z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M220.3,42.6c-2.3-0.7-3.4-2.2-3.9-4.7h3.5c0.5,1.9,2.1,2.4,4.9,2.4c2.5,0,3.6-0.5,3.6-1.6
		c0-0.4-0.2-0.8-0.4-0.9c-0.6-0.4-2-0.5-4.8-0.6c-1.4-0.1-2.5-0.2-3.4-0.5c-1.8-0.5-2.7-1.6-2.7-3.5c0-2.6,2.2-4.3,6.6-4.3
		c4.7,0,7.2,1.3,7.8,4.7h-3.4c-0.4-1.7-1.9-2.1-4.5-2.1c-2.5,0-3.4,0.6-3.4,1.5c0,0.5,0.1,0.8,0.7,1c0.6,0.2,1.7,0.4,3.6,0.5
		c1.6,0.1,2.9,0.2,4,0.5c2.1,0.6,3,1.6,3,3.5c0,2.9-2.1,4.6-6.9,4.6C222.9,43.1,221.4,43,220.3,42.6z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M240.8,39.8h3.7V32h-3.7v-2.8h10.4V32h-3.7v7.8h3.7v3h-10.4V39.8z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M264.3,42.7h-3.1V29.2h3.2l8.2,9.2l0.1,0.2v-9.4h3.1v13.5h-3.1l-8.3-9.3l-0.1-0.2V42.7z M274.8,23.7l-4.6,4.4
		h-2.5l3.6-4.4H274.8z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M289,42.6c-2.3-0.7-3.4-2.2-3.9-4.7h3.5c0.5,1.9,2.1,2.4,4.9,2.4c2.5,0,3.6-0.5,3.6-1.6c0-0.4-0.2-0.8-0.4-0.9
		c-0.6-0.4-2-0.5-4.8-0.6c-1.4-0.1-2.5-0.2-3.4-0.5c-1.8-0.5-2.7-1.6-2.7-3.5c0-2.6,2.2-4.3,6.6-4.3c4.7,0,7.2,1.3,7.8,4.7h-3.4
		c-0.4-1.7-1.9-2.1-4.5-2.1c-2.5,0-3.4,0.6-3.4,1.5c0,0.5,0.1,0.8,0.7,1c0.6,0.2,1.7,0.4,3.6,0.5c1.6,0.1,2.9,0.2,4,0.5
		c2.1,0.6,3,1.6,3,3.5c0,2.9-2.1,4.6-6.9,4.6C291.6,43.1,290.1,43,289,42.6z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M313.2,39v3.8H310V29.2h3.2v6.5l7.4-6.5h4.3l-5.9,5.1l6.2,8.4h-3.8l-4.7-6.7L313.2,39z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M333.4,39.8h3.7V32h-3.7v-2.8h10.4V32h-3.7v7.8h3.7v3h-10.4V39.8z"
        ></IconPathAnimated>
      </g>
      <g>
        <IconPathAnimated
          color={color}
          d="M182.4,15.8h-1.6V0h3.4v1.6h-1.7V7h1.7v1.6h-1.7V15.8z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M196.8,13.6V0h1.7v13.5c0,0.6,0.2,0.9,0.6,0.9c0.4,0,0.6-0.3,0.6-0.9V0h1.7v13.6c0,1.6-0.8,2.3-2.3,2.3
		S196.8,15.3,196.8,13.6z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M214.3,15.8V0h1.3l1.8,8.9l0.4,2.4l-0.3-3.4V0h1.5v15.8h-1.3l-1.9-9l-0.4-2.3l0.3,3.2v8H214.3z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M234.3,0c1.6,0,2.4,0.6,2.4,2.3v11.2c0,1.7-0.9,2.3-2.5,2.3h-2.1V0H234.3z M233.7,14.3h0.4c0.6,0,0.9-0.3,0.9-0.9v-11
		c0-0.7-0.3-0.9-0.9-0.9h-0.4V14.3z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M250.9,13.8l-0.2,2h-1.6L250.7,0h1.7l1.7,15.8h-1.6l-0.2-2H250.9z M252.2,12.3l-0.5-5.8L251.6,3l-0.1,3.6l-0.4,5.8H252.2z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M266.5,13.6V2.1c0-1.6,0.9-2.2,2.3-2.2s2.2,0.7,2.2,2.2v4.2h-1.6v-4c0-0.6-0.2-0.9-0.6-0.9c-0.4,0-0.6,0.3-0.6,0.9v11.2
		c0,0.6,0.2,0.9,0.6,0.9c0.5,0,0.6-0.3,0.6-0.9V9h1.6v4.7c0,1.6-0.8,2.3-2.3,2.3C267.3,16,266.5,15.3,266.5,13.6z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M283.9,13.6V9.2h1.6v4.3c0,0.6,0.1,0.9,0.6,0.9s0.6-0.3,0.6-0.9V0h1.7v13.6c0,1.6-0.7,2.4-2.2,2.4
		C284.5,16,283.9,15.2,283.9,13.6z"
        ></IconPathAnimated>
        <IconPathAnimated
          color={color}
          d="M302.5,13.8l-0.2,2h-1.6L302.3,0h1.7l1.7,15.8H304l-0.2-2H302.5z M303.8,12.3l-0.5-5.8L303.2,3L303,6.6l-0.4,5.8H303.8z"
        ></IconPathAnimated>
      </g>
    </IconWrapper>
  </FoundationWrapper>
)

export { FoundationLogo }
